const auth = {
    namespaced: true,
    state: {
        profile: {},
        checkingStatus: false
    },
    mutations: {
        setProfile(state, profile) {
            state.profile = profile;
        },
        checkingStatus(state, status) {
            state.checkingStatus = status;
        }
    },
    actions: {
        isCartMode({ commit, getters }, enables) {

            if(sessionStorage.getItem('dealerMode') != null && sessionStorage.getItem('dealerMode').length > 0){
                return false;
            }

            // console.log('userType', getters.userType);
            // console.log('enable_b2c', enables.enable_b2c);
            // console.log('enable_b2b', enables.enable_b2b);

            if (enables.enable_b2c == '1') {
                return true;
            }

            if (getters.userType == 'B2B' && (enables.enable_b2b == '1')) {
                return true;
            }

            return false;
        },
        async getProfile({ commit }, netsuiturl) {

            // set check status
            commit("checkingStatus", true);
            // can't use axios because of the laravel config

            await fetch(
                netsuiturl + `services/MyAccountEnvironment.Service.ss?lang=en_US&cur=USD&X-SC-Touchpoint=myaccount&t=${parseInt(
                    Date.now() / 1000
                )}`,
                {
                    credentials: "include"
                }
            )
                .then(response => {
                    if (!response.ok) {
                        throw Error(
                            "Netsuite login error: ",
                            response.statusText
                        );
                    }

                    return response.json();
                })
                .then(data => {
                    // set netsuite profile
                    var cart_no_access = "F";
                    let hideRRStock = "F";
                    let nobulkbuydiscount = "F";
                    if(data.ENVIRONMENT.PROFILE.customfields && data.ENVIRONMENT.PROFILE.customfields.length)
                        for (var i = 0; i < data.ENVIRONMENT.PROFILE.customfields.length; i++) {
                            if(data.ENVIRONMENT.PROFILE.customfields[i].name && (data.ENVIRONMENT.PROFILE.customfields[i].name == 'custentity_cust_no_cart_access'))
                            {
                                if(data.ENVIRONMENT.PROFILE.customfields[i].value)
                                {
                                    cart_no_access = data.ENVIRONMENT.PROFILE.customfields[i].value;
                                }
                            }

                            if( data.ENVIRONMENT.PROFILE.customfields[i].name && (data.ENVIRONMENT.PROFILE.customfields[i].name == 'custentity_donot_show_rrstock'))
                                hideRRStock = data.ENVIRONMENT.PROFILE.customfields[i].value;

                            if( data.ENVIRONMENT.PROFILE.customfields[i].name && (data.ENVIRONMENT.PROFILE.customfields[i].name == 'custentity_nobuilkbuydiscount')) {
                                nobulkbuydiscount = data.ENVIRONMENT.PROFILE.customfields[i].value;
                            }
                        }
                    var address_state = null;
                    if(data.ENVIRONMENT.ADDRESS && data.ENVIRONMENT.ADDRESS.length)
                        for (var i = 0; i < data.ENVIRONMENT.ADDRESS.length; i++) {
                            if(data.ENVIRONMENT.ADDRESS[i].state && (data.ENVIRONMENT.ADDRESS[i].state != '') && (data.ENVIRONMENT.ADDRESS[i].defaultshipping == 'T'))
                            {
                                address_state = data.ENVIRONMENT.ADDRESS[i].state;
                                break;
                            }
                        }

                    commit("setProfile", { isLoggedIn: data.ENVIRONMENT.PROFILE.isLoggedIn,
                        type: data.ENVIRONMENT.PROFILE.type,
                        email: data.ENVIRONMENT.PROFILE.email,
                        companyname : data.ENVIRONMENT.PROFILE.companyname,
                        firstname : data.ENVIRONMENT.PROFILE.firstname,
                        lastname : data.ENVIRONMENT.PROFILE.lastname,
                        internalid :  data.ENVIRONMENT.PROFILE.internalid,
                        subsidiary :  data.ENVIRONMENT.PROFILE.subsidiary,
                        cart_no_access : cart_no_access,
                        address_state : address_state,
                        hideRRStock: hideRRStock,
                        nobulkbuydiscount: nobulkbuydiscount
                    });
                    // unset status
                    commit("checkingStatus", false);

                    // b2b analytics
                    if(data.ENVIRONMENT.PROFILE.isLoggedIn == 'T' && data.ENVIRONMENT.PROFILE.email) {
                        let csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;
                        let culture = window.culture;

                        fetch(`/${culture}/api/b2b-analytics`, {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                                "X-CSRF-Token": csrfToken,
                            },
                            method: "post",
                            credentials: "same-origin",
                            body: JSON.stringify({
                                firstname: data.ENVIRONMENT.PROFILE.firstname,
                                lastname: data.ENVIRONMENT.PROFILE.lastname,
                                email: data.ENVIRONMENT.PROFILE.email,
                                companyname: data.ENVIRONMENT.PROFILE.companyname,
                                culture: culture,
                            }),
                        });
                    }
                })
                .catch(error => { });
        },
        async logout({ commit }, netsuiturl) {
            await fetch(
                netsuiturl + "logOut.ssp?is=login&logoff=T&ckabandon=T",
                {
                    credentials: "include",
                    mode: "no-cors"
                }
            )
                .then(() => {
                    commit("setProfile", {});
                })
                .catch(error => { });
        }
    },
    getters: {
        userIsLoggedIn: state => {
            if (
                state.profile &&
                state.profile.type &&
                state.profile.type !== "0"
            ) {
                return true;
            }

            return false;
        },
        userType: state => {

            if (state.profile.type && state.profile.type == "COMPANY") {
                return "B2B";
            }

            return "B2C";
        },
        cartNoAccess: state => {
            if (state.profile.cart_no_access && state.profile.cart_no_access == "T")
                return true;
            else
                return false;
        },
        showRhinoRackStock: state => {
            return state.profile.hideRRStock == 'F' ? true : false;
        },
        noBulkBuyDiscount: state => {
            return state.profile.nobulkbuydiscount == 'T' ? true : false;
        }
    }
};

export default auth;
